import {
  Avatar,
  Box,
  Flex,
  Image,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { selectAvatar } from "@/reducer/userslice";

import { MsUser } from "@/types/msuser";

type Props = {
  sessionContent: MsUser;
};

const MySessionItem = (props: Props) => {
  const { sessionContent } = props;
  const avatar = useSelector(selectAvatar);

  const isBase64Image = (str:string) =>{
    const regex = /^data:image\/(\w+);base64,/;
    return regex.test(str);
  }

  return (
    <>
      <Flex justifyContent={"flex-end"} alignItems="flex-start" mb="10px">
        <Box maxW={"70%"}>
          <Box
            bgColor={"#496AE1"}
            p="10px"
            borderRadius={"5px"}
            boxSizing="border-box"
            color={"#FFFFFF"}
            fontSize="14px"
            mb={"20px"}
          >
            {!isBase64Image(sessionContent.content) && sessionContent.content}
            {isBase64Image(sessionContent.content) && <Image boxSize={"200px"} src={sessionContent.content} />}
          </Box>
        
        </Box>
        <Avatar
          ml="14px"
          w="40px"
          h="40px"
          name="ALDGPT"
          borderRadius={"2px"}
          src={avatar}
        />
      </Flex>
    </>
  );
};

export default MySessionItem;
